/**
 * Bundled fallback copy of the gateway `/config/labels` response.
 *
 * Used to seed InteractionLabelsService so the UI works in direct/dev mode and
 * before the TYPO3 proxy route (gitterdan-website#23) exists. Mirrors
 * data-science/gateway `gateway/api/labels.py`. Identifiers (keys) are the
 * stable contract; the English text is "suggested" and may drift — i18n
 * (src/i18n/locales/*.json) is the source of truth for display copy.
 */

/** Top-level group name -> identifier -> suggested English label. */
export type LabelGroups = Record<string, Record<string, string>>;

export const DEFAULT_INTERACTION_LABELS: LabelGroups = {
  interaction_type: {
    DeonticContradiction: 'Opposing obligations',
    NumericContradiction: 'Conflicting numeric limits',
    QualityContradiction: 'Conflicting quality requirements',
    ActionContradiction: 'Conflicting procedural requirements',
    DefinitionalContradiction: 'Conflicting definitions',
    SpecialisCompetition: 'General vs specific rule',
    TemporalCompetition: 'Newer rule supersedes older',
    HierarchicalCompetition: 'Higher authority supersedes lower',
    Collision: 'Functional interference between rules',
    Reinforcement: 'Mutually reinforcing rules',
    NearDuplicate: 'Near-duplicate rules',
    NormativeSubsumption: 'One rule contains the other',
    Analogy: 'Analogous rules across domains',
    CoverageGap: 'Unaddressed subject',
  },
  defeat_type: {
    Rebutting: 'Directly overridden by a stronger rule',
    Undercutting: 'Exception applies — not an error',
    Undermining: 'Premise no longer holds',
  },
  resolution_maxim: {
    LexSpecialis: 'More specific rule applies',
    LexPosterior: 'More recent rule applies',
    LexSuperior: 'Higher authority applies',
    DefeasibleOverride: 'Defeasible override',
  },
};
